import { FC, memo } from 'react'
import { useSubscribeToAuthState } from './hooks/auth/useSubscribeToAuthState'
import { useRefreshAuthTokenOnClaimsChange } from './hooks/auth/useRefreshAuthTokenOnClaimsChange'
import { useSubscribeToCompanyChanges } from './hooks/company/useSubscribeToCompanyChanges'

const Bootstrap: FC = () => {
  useSubscribeToAuthState()
  useRefreshAuthTokenOnClaimsChange()
  useSubscribeToCompanyChanges()
  return null
}

export default memo(Bootstrap)
